module.exports = __webpack_public_path__ + "img/icon-reset.0c67e545.svg";